
import React, { memo, useEffect, useRef, useState } from 'react'
import TimelinePlugin from "wavesurfer.js/dist/plugins/timeline";
import Wavesurfer from 'wavesurfer.js';
import { Pause, PlayArrowSharp } from '@mui/icons-material'
import { useSelector } from 'react-redux';
import { WrapRecord, AudioTitle, ChangeAudioSetting, BasicRecord, Action } from './Style'
import { thirdly } from 'styles/theme';
import { Progress, ChangeSetting, surferHooks, HeaderSettings, FooterSettings } from 'components/Record'
import { useTheme } from 'styles';
import { assign } from 'lodash';
import { wavesurferToTime } from 'utils/formatter';
import { actions } from 'store';
import { useDispatch } from 'react-redux';
import { Label } from 'components/Form';
import { SpaceBetween } from 'styles/GlobalStyle';
import './Record.css'
import { Can } from 'components/Permissions';
import { features } from 'keys';

const Record = (props) => {
    const { rate: customRate, hideHeader, file, autoplay, stopAudioAfterSeconds, showTimeline, height = 50, id = "basic-record", hidden, changeSetting } = props

    const [isReady, setIsReady] = useState(false)

    const { Layout } = useTheme()
    const dispatch = useDispatch()
    const pathAudioRef = useRef(null);

    const { assessment } = useSelector(state => state.assessment)
    const { isPlaying, zoomIn, wavesurfer, ignoreActions } = useSelector(state => state.wavesurfer)

    const [rate, setRate] = useState(customRate || 1)

    const onPlayPause = surferHooks.useOnPlayPause()
    const onPause = surferHooks.useOnPause()
    const downloadAudio = surferHooks.useDownload()
    const onMount = surferHooks.useOnMount()
    const plugins = surferHooks.usePlugins()

    const audioFile = file || assessment.audio_file

    useEffect(() => {
        let isSeekingManually = false;

        // Add event listener for spacebar key press
        const handleKeyPress = (event) => {
            if (ignoreActions)
                return

            switch (event.code) {
                case 'Space':
                    onPlayPause();
                    event.preventDefault()
                    break
                case 'ArrowLeft':
                    wavesurfer.skip(-2)
                    event.preventDefault()
                    break
                case 'ArrowRight':
                    wavesurfer.skip(2)
                    event.preventDefault()
                    break
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        // We removed the delay from the audio skip time Because it gave us problems when we used the 2 second forward and back buttons and it caused the audio to stop which is not the desired behavior

        // wavesurfer?.on('seeking', () => {
        //     isSeekingManually = true;
        //     onPause()
        //     setTimeout(() => {
        //         isSeekingManually = false;
        //     }, 100); // Adjust the timeout as needed to consider the duration of a manual seek
        // });

        // wavesurfer?.on('ready', () => {
        //     setIsReady(true)
        // });

        wavesurfer?.on('finish', () => {
            onPause()
        });

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [isPlaying, wavesurfer, zoomIn, rate, ignoreActions]);


    useEffect(() => {
        return () => {
            onPause()
            dispatch(actions.setWavesurfer(null))
        }
    }, [])


    useEffect(() => {
        if (audioFile) {
            let nWs = {
                container: `#${id}`,
                waveColor: '#bfbfc5',
                progressColor: thirdly,
                height: 50,
                normalize: true,
                minPxPerSec: 70,
                audioRate: rate,
                plugins: []
            }
            if (showTimeline) {
                nWs.plugins.push(TimelinePlugin.create({
                    timeInterval: 0.1,
                    primaryLabelInterval: 1,
                    style: {
                        color: "#838386"
                    }
                }))
            }
            const ws = Wavesurfer.create(nWs);


            onMount(ws, stopAudioAfterSeconds)

            ws.load(audioFile);

            ws.on('ready', () => {
                setIsReady(true);
            });
        }

        return () => {
            wavesurfer?.destroy();
        };
    }, [audioFile, id, zoomIn]);

    return (
        <WrapRecord className='record-item' $hidden={hidden} $basic={true} $changeSetting={changeSetting}>
            {hideHeader ||
                <AudioTitle style={{ ...Layout.shrink, ...Layout.flex, ...Layout.scGap }}>
                    {assessment.id &&
                        <Can I="read" a={features.transcription_system}>
                            <Label bold label={`מבדק ${assessment.id}`} fontSize={16} />
                        </Can>
                    }
                    {assessment.reading_assessment_title}
                    <SpaceBetween />
                    {isReady && changeSetting &&
                        <HeaderSettings
                            rate={rate}
                            {...props}
                        />
                    }
                </AudioTitle>}
            <div style={{ ...Layout.grow }}>
                {audioFile ?
                    <>
                        {!isReady && <Progress />}
                        <ChangeAudioSetting>
                            {isReady &&
                                <div style={assign(Layout.rowCenter, Layout.scGap)}>

                                    {/* <Action onClick={downloadAudio}>
                                        {<DownloadRounded />}
                                    </Action> */}
                                    {wavesurferToTime(wavesurfer?.getDuration())}
                                </div>
                            }

                            <BasicRecord $hidden={!isReady} id={id} className='basic-record' />

                            {isReady &&
                                <Action color='gray' onClick={onPlayPause}>
                                    {isPlaying ? <Pause /> : <PlayArrowSharp />}
                                </Action>
                            }

                        </ChangeAudioSetting>
                    </>
                    :
                    <Progress />
                }
            </div>
            {isReady && changeSetting && <FooterSettings />}
        </WrapRecord >
    )
}


const isRender = (prev, next) => {
    return false
}


export default memo(Record, isRender)


